import { useEffect, useState } from "react";
import { STORAGE } from "../constants";
import { LocalStorageService } from "../services/LocalStorageService";

function useAccounts() {

    const [accounts] = useState(LocalStorageService.get(STORAGE.ACCOUNTS_ASSIGNED))

    return { accounts }
}
export default useAccounts